import React from 'react'
import {BsTwitter,BsInstagram,BsLinkedin, BsGithub} from 'react-icons/bs'
import './footer.css'

function Footer() {
  return (
    <footer>
      <a href='#' className='footer__logo'>Guduru Chetan</a>

      <ul className='permalinks'>
        <li><a href='#'>Home</a></li>
        <li><a href='#about'>About</a></li>
        <li><a href='#experience'>Experience</a></li>
        <li><a href='#portfolio'>Portfolio</a></li>
        <li><a href='#contact'>Contact</a></li>
      </ul>

      <div className='footer__socials'>
        <a href='https://www.twitter.com'><BsTwitter/></a>
        <a href='https://www.instagram.com'><BsInstagram/></a>
        <a href='https://www.linkedin.com'><BsLinkedin/></a>
        <a href='https://www.github.com'><BsGithub/></a>
      </div>

      <div className='footer__copyright'>
        <small>&copy; Guduru Chetan. All rights reserved</small>
      </div>
    </footer>
  )
}

export default Footer